import { useMutation } from 'react-apollo';
import { DataProxy } from 'apollo-cache';
import * as mutation from './mutation.gql';
import {
  CancelOrderMutation as Mutation,
  CancelOrderMutationVariables as Variables,
} from './__generated__/CancelOrderMutation';
import { orderListQuery } from 'queries/OrderList';
import { OrderListQuery } from 'queries/OrderList/__generated__/OrderListQuery';
import { mainAccountQuery } from 'shared/queries/MainAccountsQuery/builder';
import { ideaQuery } from 'queries/IdeaQuery/builder';
import { cloneDeep } from 'lodash';
import { Investment_IdeaType } from 'types/common';

const updateLabOrderList = (orderId: number) => (store: DataProxy) => {
  const query = orderListQuery({ archived: false });
  const data = store.readQuery<OrderListQuery>(query);
  if (!data) {
    return;
  }

  const newData = cloneDeep(data);
  newData.lab.buyOrders.list = data.lab.buyOrders.list.filter(
    (order) => !(order.__typename === 'Investment_BuyOrder' && order.id === orderId)
  );

  store.writeQuery<OrderListQuery>({ ...query, data: newData });
};

export const useCancelMutation = (
  orderId: number,
  ideaType: Investment_IdeaType,
  ideaId?: number
) => {
  const [cancel, { error, loading }] = useMutation<Mutation, Variables>(mutation, {
    variables: {
      id: orderId,
      ideaType,
    },
    refetchQueries: [mainAccountQuery(), ...(ideaId ? [ideaQuery({ id: ideaId })] : [])],
    update: updateLabOrderList(orderId),
  });

  return {
    cancel: () => cancel(),
    loading,
    error,
  };
};
